import { connect } from "react-redux";
import Reflections from "../components/Reflections";

const mapStateToProps = state => ({
  invertedTheme: state.ui.invertedTheme,
  parts: state.book.book ? state.book.book.parts : []
});

export default connect(mapStateToProps)(Reflections);



// WEBPACK FOOTER //
// ./src/containers/ReflectionsContainer.js